import React, { useState, useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";

import { CartProvider } from "./CartContext";
import NavBar from "./NavBar";
import "../styles/Layout.css";
import ScrollToTop from "./ScrollToTop";
import UniversalFooter from "./UniversalFooter";
import useGTMPageView from "./useGTMPageView";
import useMetaPixel from "./useMetaPixel";

export default function Layout() {
  useGTMPageView();
  // useMetaPixel();

  const location = useLocation();
  const navbarRef = useRef(null);
  const [paddingTop, setPaddingTop] = useState(0);

  // Pages that require extra padding
  const pagesWithExtraPadding = [
    "/shop",
    "/design",
    "/returns-and-exchanges",
    "/legal-and-cookies",
    "/legal-and-cookies/privacy-policy",
    "management",
  ];

  // Function to check if the current path matches any of the specified paths
  const shouldAddPadding = () => {
    const isDesktop = window.innerWidth > 768;

    if (isDesktop) {
      return pagesWithExtraPadding.some((path) =>
        location.pathname.match(new RegExp(path.replace(":id", "\\d+")))
      );
    } else {
      return pagesWithExtraPadding.some((path) => location.pathname === path);
    }
  };

  useEffect(() => {
    const updatePadding = () => {
      if (navbarRef.current) {
        const navbarHeight = navbarRef.current.offsetHeight;
        let additionalPadding = 0;
        // if (!(window.innerWidth <= 768)) {
        //   additionalPadding = 60; // Add extra pixels for mobile
        // }
        setPaddingTop(navbarHeight + additionalPadding);
      }
    };
    updatePadding();
    window.addEventListener("resize", updatePadding);
    return () => {
      window.removeEventListener("resize", updatePadding);
    };
  }, []);
  return (
    <CartProvider>
      <ScrollToTop />
      <div className="site-wrapper">
        <div className="header-container">
          {/* <div id="top-header" className="top-header">
            Important information here
          </div> */}
          <NavBar ref={navbarRef} />
        </div>
        <main
          className="content"
          style={{ paddingTop: shouldAddPadding() ? `${paddingTop}px` : "0" }}
        >
          <Outlet />
        </main>
        <UniversalFooter />
      </div>
    </CartProvider>
  );
}
